export const APP = {
    ENVIRONMENT: process.env.VUE_APP_ENVIRONMENT,
    API_URL: process.env.VUE_APP_API_URL,
    PAYPAL_ENVIRONMENT: process.env.VUE_APP_PAYPAL_ENVIRONMENT,
    PAYPAL_CREDENTIALS: {
        sandbox: process.env.VUE_APP_PAYPAL_SANDBOX_CLIENT_ID,
        production: process.env.VUE_APP_PAYPAL_PRODUCTION_CLIENT_ID,
    },
};
